"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LambdaLogger = void 0;
const util_1 = require("util");
const winston_1 = __importDefault(require("winston"));
const Utility_1 = require("./Utility");
const Labels_1 = require("./Labels");
const RequestContext_1 = require("./RequestContext");
class LambdaLogger {
    constructor(loggerLevel) {
        this.logger = winston_1.default.createLogger({
            format: winston_1.default.format.combine(winston_1.default.format.simple(), winston_1.default.format.printf((msg) => `[${msg.level}] ${msg.message}`)),
            transports: [new winston_1.default.transports.Console()],
            level: loggerLevel.toString(),
        });
    }
    setLevel(loggerLevel) {
        this.logger.level = loggerLevel.toString();
    }
    error(message, ...optionalParams) {
        this.logger.error(this.formatMessage(message, optionalParams, { showHidden: true }));
    }
    warn(message, ...optionalParams) {
        this.logger.warn(this.formatMessage(message, optionalParams));
    }
    info(message, ...optionalParams) {
        this.logger.info(this.formatMessage(message, optionalParams));
    }
    debug(message, ...optionalParams) {
        this.logger.debug(this.formatMessage(message, optionalParams));
    }
    verbose(message, ...optionalParams) {
        this.logger.verbose(this.formatMessage(message, optionalParams));
    }
    silly(message, ...optionalParams) {
        this.logger.silly(this.formatMessage(message, optionalParams));
    }
    formatMessage(message, optionalParams, options) {
        let msgArray = [];
        // inject request context data if available
        const requestId = RequestContext_1.RequestContext.store()?.get(Labels_1.Labels.RequestId);
        if (requestId) {
            msgArray.push(`requestId(${requestId})`);
        }
        const correlationId = RequestContext_1.RequestContext.store()?.get(Labels_1.Labels.CorrelationId);
        if (correlationId && correlationId !== requestId) {
            msgArray.push(`correlationId(${correlationId})`);
        }
        const decodedToken = RequestContext_1.RequestContext.store()?.get(Labels_1.Labels.Authorization);
        if (decodedToken) {
            const principalId = Utility_1.Utility.getPrincipal(decodedToken);
            msgArray.push(`principalId(${principalId})`);
        }
        msgArray.push(this.format(message, options));
        const formattedParams = optionalParams.map((param) => {
            return this.format(param, options);
        });
        msgArray = msgArray.concat(formattedParams);
        return msgArray.join(' ');
    }
    format(message, options) {
        const inspectOptions = {
            depth: LambdaLogger.MAX_DEPTH,
            ...options,
        };
        if (typeof message === 'string') {
            return message;
        }
        try {
            return JSON.stringify(message, this.replacer);
        }
        catch (err) {
            return util_1.inspect(message, inspectOptions);
        }
    }
    replacer(key, value) {
        if (value instanceof Error) {
            return Utility_1.Utility.enumerableErrors(value);
        }
        return value;
    }
}
exports.LambdaLogger = LambdaLogger;
LambdaLogger.MAX_DEPTH = 5;
//# sourceMappingURL=LambdaLogger.js.map